module.exports = "<div id=\"central-weights-plot\"></div>";